import React from "react";

import { ISnippet } from "../../../interfaces";
import CssOverride from "../../css-override";
import { SNIPPETS } from "./helpers/constants";
import Calculator from "./helpers/calculator";
import WhereToBuyFooter from "./helpers/where-to-buy-footer";
import WhereToBuyHeader from "./helpers/where-to-buy-header";
import WhereToBuyInPage from "./helpers/where-to-buy-in-page";
import ColorOptionsLookup from "./helpers/color-options-lookup";
import PreliminaryHeightGuide from "./helpers/preliminary-height-guides";
import StaffDirectory from "./helpers/staff-directory";

class SnippetBroker extends React.Component<ISnippet> {
  FormattedSnippet;

  constructor(snippet) {
    super(snippet);
    switch (snippet.data?.attributes?.name) {
      case SNIPPETS.WHERE_TO_BUY_HEADER:
        this.FormattedSnippet = CssOverride(WhereToBuyHeader, snippet);
        break;
      case SNIPPETS.CALCULATOR:
        this.FormattedSnippet = CssOverride(Calculator, snippet);
        break;
      case SNIPPETS.WHERE_TO_BUY_FOOTER:
        this.FormattedSnippet = CssOverride(WhereToBuyFooter, snippet);
        break;
      case SNIPPETS.WHERE_TO_BUY_IN_PAGE:
        this.FormattedSnippet = CssOverride(WhereToBuyInPage, snippet);
        break;
      case SNIPPETS.WHERE_TO_BUY_HEADER_PB:
        this.FormattedSnippet = CssOverride(WhereToBuyHeader, snippet);
        break;
      case SNIPPETS.WHERE_TO_BUY_FOOTER_PB:
        this.FormattedSnippet = CssOverride(WhereToBuyFooter, snippet);
        break;
      case SNIPPETS.WHERE_TO_BUY_HEADER_RH:
        this.FormattedSnippet = CssOverride(WhereToBuyHeader, snippet);
        break;
      case SNIPPETS.WHERE_TO_BUY_FOOTER_RH:
        this.FormattedSnippet = CssOverride(WhereToBuyFooter, snippet);
        break;
      case SNIPPETS.WHERE_TO_BUY_HEADER_RR:
        this.FormattedSnippet = CssOverride(WhereToBuyHeader, snippet);
        break;
      case SNIPPETS.WHERE_TO_BUY_FOOTER_RR:
        this.FormattedSnippet = CssOverride(WhereToBuyFooter, snippet);
        break;
      case SNIPPETS.COLOR_OPTIONS_LOOKUP:
        this.FormattedSnippet = CssOverride(ColorOptionsLookup, snippet);
        break;
      case SNIPPETS.PRELIMINARY_HEIGHT_GUIDE:
        this.FormattedSnippet = CssOverride(PreliminaryHeightGuide, snippet);
        break;
      case SNIPPETS.STAFF_DIRECTORY:
        this.FormattedSnippet = CssOverride(StaffDirectory, snippet);
        break;
      default:
        console.error(`${snippet.data?.attributes?.name} does not exist.`);
      // throw new Error(`${snippet.name} does not exist.`)
    }
  }

  render() {
    return this.FormattedSnippet ? (
      <>
        <this.FormattedSnippet />
      </>
    ) : (
      <div />
    );
  }
}

export default SnippetBroker;
